export * from './src/TrustpilotWidget';
